import {
  Dashboard,
  DashboardCreate,
  DashboardUpdate,
} from 'src/types/dashboard';
import { RenameFolderResponse } from 'src/types/share';
import { baseAPICreator } from './apiCreator';

const dashboardApi = baseAPICreator('/dashboard');

/** GET /dashboard/all — owned + shared dashboards for the caller's org */
export const getDashboards = async (): Promise<Dashboard[]> => {
  const { data } = await dashboardApi.get('/all');
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data?.dashboards)) {
    return data.dashboards;
  }
  return [];
};

/** PATCH /dashboard/folders/rename — moves folder share grants with the rename */
export const renameDashboardFolder = async (
  from: string,
  to: string
): Promise<RenameFolderResponse> => {
  const { data } = await dashboardApi.patch<RenameFolderResponse>(
    '/folders/rename',
    { from, to }
  );
  return data;
};

export const createDashboard = async (
  apiKey: string,
  dashboard: DashboardCreate
): Promise<Dashboard> => {
  const { data } = await dashboardApi.post(`?secretKey=${apiKey}`, dashboard);
  return data;
};

export const updateDashboard = async (
  apiKey: string,
  dashboardId: string,
  dashboard: DashboardUpdate
) => {
  const { data } = await dashboardApi.put(
    `/${dashboardId}?secretKey=${apiKey}`,
    dashboard
  );
  return data;
};

export const deleteDashboard = async (apiKey: string, dashboardId: string) => {
  const { data } = await dashboardApi.delete(
    `/${dashboardId}?secretKey=${apiKey}`
  );
  return data;
};

export const toggleFavoriteDashboard = async (
  apiKey: string,
  dashboardId: string,
  favorite: boolean
) => {
  const { data } = await dashboardApi.put(
    `/${dashboardId}/favorite?secretKey=${apiKey}`,
    {
      favorite,
    }
  );
  return data;
};

export const getDashboardShowIds = async (
  dashboardId: string
): Promise<{ showIds: string[] }> => {
  const { data } = await dashboardApi.get(`${dashboardId}/shows`);
  return data;
};
